import { format } from 'date-fns'

export const dottedDateFormat = 'dd.MM.yyyy'

export const dottedDateTimeFormat = 'dd.MM.yyyy HH:mm'

export const kebabCaseDateFormat = 'yyyy-MM-dd'

export const formatToDottedDateFormat = (date: Date) =>
  format(date, dottedDateFormat)

export const formatToDottedDateTimeFormat = (date: Date) =>
  format(date, dottedDateTimeFormat)

export const formatToKebabCseDateFormat = (date: Date) =>
  format(date, kebabCaseDateFormat)
